import React from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {validate as validateEmail} from  "react-email-validator"
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { 
    selectStatusMessage,
    selectIsInProgress,
    doLogInAsync, 
    doLogOutAsync, 
    doGetAuthenticatedUserAsync, 
    selectOperationResult,
    selectStatus,
    selectIsRegistered
} from "./logonSlice";
import navigationPaths from "../../engine/navigationPaths";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { AuthGoogleLogin } from "components/externalLogin/google/authGoogleLogin";
import urls from "engine/urls";
import { AuthFacebookLogin } from "components/externalLogin/facebook/authFacebookLogin";
import { AuthLinkedinLogin } from "components/externalLogin/linkedin/authLinkedInLogin";
import {Stack} from "@mui/material";

function LogInComponent(props) {

    console.log("REACT_APP_SHOW_EXTERNAL_LOGIN_PROVIDERS: " + process.env.REACT_APP_SHOW_EXTERNAL_LOGIN_PROVIDERS);
    const statusIdle = "idle";
    const statusError = "error";

    const dispatch = useDispatch();
    const message = useSelector(selectStatusMessage);
    const registered = useSelector(selectIsRegistered);
    const navigate = useNavigate();
    const inProgress = useSelector(selectIsInProgress);
    const operationErrorMessage = useSelector(selectOperationResult);
    const status = useSelector(selectStatus);

    const [isEmailProvided, setisEmailProvided] = React.useState(true);
    const [isPasswordProvided, setisPasswordProvided] = React.useState(true);
    
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
     event.preventDefault();
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        setisEmailProvided(true);
        setisPasswordProvided(true);

        const data = new FormData(e.currentTarget);
        if(!validate(data)){
               return; 
        }
        var logInData = {
            email: data.get("email"),
            password: data.get("password"),
        };
        
        dispatch(doLogInAsync(logInData)).unwrap().then(             
            (r) => {
                 props.onSuccess();            
            }                 
        );
    }

    const enableNavigation = props?.enableNavigation ?? false;

    const validate= (data) => {
        var isValid = true;
        var email = data.get("email");
        var password = data.get("password");
        if( email == ''){
            isValid = false;
            setisEmailProvided(false);
        }      
        if(!validateEmail(email)){
            isValid = false;
            setisEmailProvided(false);
        }       
        if(password == ''){
            isValid = false;
            setisPasswordProvided(false);
        }
        return isValid;
    }

    const handleLogOut = (e) => {
        e.preventDefault();
        dispatch(doLogOutAsync());
    };

    const navigateToInvoiceList = ()=>{
        dispatch(doGetAuthenticatedUserAsync()).unwrap().then(()=> {
            navigate(navigationPaths().Invoices)
        });
    }

    return (
        <MDBox component="form" onSubmit={handleSubmit} noValidate >
            <MDInput id='logon-email-field' margin="normal" required fullWidth label="Twój adres e-mail" error={!isEmailProvided} name="email" helperText={!isEmailProvided? "Niepoprawny email":""} autoComplete="email" autoFocus />
            <MDInput id='logon-password-field' margin="normal" type={showPassword ? 'text' : 'password'}  required fullWidth name="password" label="Twoje hasło" error={!isPasswordProvided}  autoComplete="password" 
              InputProps={{
                endAdornment: 
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="Pokaż hasło"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>     }} 
            />         
            {status == "error" && <MDTypography sx={{ mt: 2}} color="error" fontSize={14} margin="normal" align="center" fullWidth name="invalid-data">Niepoprawne dane logowania</MDTypography>} 
            <MDButton type="submit" id="login" fullWidth variant="contained" color='info' disabled={inProgress} sx={{ mt:1, mb: 4, textTransform:'none',fontSize:'14px' }}>Zaloguj się</MDButton>
            {(process.env.REACT_APP_SHOW_EXTERNAL_LOGIN_PROVIDERS === 'true')  && 
            <Stack spacing={1}>
                <AuthGoogleLogin url={urls().LoginGoogle} onSuccess={navigateToInvoiceList}/>
                <AuthFacebookLogin url={urls().LoginFacebook} onSuccess={navigateToInvoiceList}/>
                <AuthLinkedinLogin url={urls().LoginLinkedIn} onSuccess={navigateToInvoiceList}  appId={process.env.REACT_APP_LINKEDIN_APP_ID}/>
            </Stack>}
        </MDBox>
    );
}
export default LogInComponent;
